if  ($('.js-partnersSlider').length > 0 && $(window).width() > 1199){
	const partnersSlider = new Swiper($('.js-partnersSlider .swiper-container'), {
		slidesPerView: 4,
		spaceBetween: 30,
		navigation: {
			nextEl: '.js-partnersSliderNext',
			prevEl: '.js-partnersSliderPrev',
		},
	});
}
